import React from 'react';
import * as LucideIcons from 'lucide-react';
import { Service } from '../../types';

interface ServiceCardProps {
  service: Service;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  const IconComponent = (LucideIcons as any)[service.icon.charAt(0).toUpperCase() + service.icon.slice(1)];
  
  return (
    <div className="card card-hover p-8 flex flex-col h-full transition-all duration-300 group">
      <div className="h-16 w-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
        {IconComponent && <IconComponent size={32} className="text-primary" />}
      </div>
      <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
      <p className="text-neutral-300">{service.description}</p>
    </div>
  );
};

export default ServiceCard;